/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import React, {useState} from 'react';
import LoginView from "../../views/auth/LoginView";
import {CHECK_EMAIL} from "../../data/formats";
import {useAuth} from "../../data/userContext";
import {Navigate, useLocation} from "react-router-dom";
import {isAuthenticated} from "../../data/roles";

function LoginRoute(props) {
    const [credentials, setCredentials] = useState({email: "", password: ""})
    const [submitting, setSubmitting] = useState(false)
    const auth = useAuth();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";
    const [info, setInfo] = useState({text: "", severity: ""})
    const changeEmail = (e) => {
        setCredentials({...credentials, email: e.target.value})
    }

    const changePassword = (e) => {
        setCredentials({...credentials, password: e.target.value})
    }
    const submitLoginForm = (e) => {
        e.preventDefault();
        setSubmitting(true)
        if(!CHECK_EMAIL.test(credentials.email)) {
            //Failed email format
            setSubmitting(false)
            setInfo({text: "Email má nesprávny formát", severity: "warning"})
            return
        }
        auth.signin(credentials, ()=>{
            setSubmitting(false)
            //SUCCESS LOGIN
            setInfo({text: "Úspešne prihlásený", severity: "success"})
        }, ()=>{
            setSubmitting(false)
            //BAD LOGIN
            setInfo({text: "Nepodarilo sa prihlásiť.", severity: "error"})
        })
    }
    if (isAuthenticated(auth.user)){
        return <Navigate replace to={from}/>
    }else{
        return <LoginView submit={submitLoginForm}
                      isSubmitting={submitting}
                      onPasswordChange={changePassword}
                      onEmailChange={changeEmail}
                      creds={credentials}
                      info={info}
        />;
    }
}

export default LoginRoute;